import { DefaultError, useInfiniteQuery } from '@tanstack/react-query';
import { useInfiniteHandler } from 'hooks';
import { apiClient } from 'utils';
import { getDefaultInfinitePageParam } from 'utils/service/defaultInfinitePageParam';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IContact, IContactParams } from './types';

export const useGetContactsListInfinite = (params: IContactParams) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, setTotalPageCount } = useInfiniteHandler();

  const { itemCount, page } = getDefaultInfinitePageParam(
    params.page,
    params.itemCount
  );

  return useInfiniteQuery<IContact[], DefaultError>({
    queryKey: ['contacts', params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: 'GET',
        url: 'UserManagement/GetContacts',
        params: { ...params, itemCount, page: pageParam },
      });

      const value = await responseHandler<IContact[]>(response, {
        groupName: `useGetContactsListInfinite - ${pageParam}`,
      });

      setTotalPageCount(
        !!value.length ? (pageParam as number) + 2 : (pageParam as number)
      );

      return value;
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
  });
};
